import React, {Dispatch, FC, MouseEventHandler, SetStateAction, useState} from "react";
import {LearnCategory} from "../../../lib/src/api/repositories/learn-repository";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheck, faPencil, faThumbtack} from "@fortawesome/free-solid-svg-icons";
import {useNavigate} from "react-router-dom";
import {LearnIcon} from "../pages/learn/LearnIcon";
import {faArrowRightArrowLeft, faThumbtackSlash, faX} from "@fortawesome/pro-solid-svg-icons";
import {RoundedContextMenu} from "../../../lib/src/components/content/ContextMenu";
import {DeleteLearnCategoryModal} from "../modals/DeleteLearnCategoryModal";
import {EditLearnCategoryModal} from "../modals/EditLearnCategoryModal";
import {PinLearnCategoryModal} from "../modals/PinLearnCategoryModal";
import {UnpinLearnCategoryModal} from "../modals/UnpinLearnCategoryModal";
import {MoveLearnCategoryModal} from "../modals/MoveLearnCategoryModal";
import {useModal} from "@jane/lib/src/components/layout/ModalProvider";

export const CategoryList: FC<{ categories: LearnCategory[], allCategories: LearnCategory[], reload: () => void, selected: string[], setSelected: Dispatch<SetStateAction<string[]>> }> = (props) => {


  return <>
  {props.categories.length > 0 ? <>
    {props.categories.map((category, index) => {
      return <CategoryRow
        key={index}
        category={category}
        categories={props.allCategories}
        isFirst={index === 0}
        isLast={index === props.categories.length - 1}
        selectedCategories={props.selected}
        setSelectedCategories={props.setSelected}
        toggleSelectCategory={(id) => {
          props.setSelected(old => old.includes(id) ? old.filter(x => x !== id) : [...old, id])
        }}
        reload={props.reload}
      />
    })}
  </> : <>
    <div className={'px-4 py-3 border border-slate-200 bg-white rounded-sm flex justify-center items-center'}>
      <div>Er zijn nog geen (sub)categorien</div>
    </div>
  </>}
  </>
}

const CategoryRow: FC<{
  category: LearnCategory,
  categories: LearnCategory[],
  isFirst: boolean,
  isLast: boolean,
  selectedCategories: string[],
  setSelectedCategories: Dispatch<SetStateAction<string[]>>,
  toggleSelectCategory: (id: string) => void,
  reload: () => void,
}> = (props) => {
  const navigate = useNavigate()
  const {open: moveCategoryModal} = useModal({title: 'Verplaats categorie', body: <MoveLearnCategoryModal category={props.category} categories={props.categories} reload={props.reload} />, size: 'md'})
  const {open: editCategoryModal} = useModal({title: 'Pin categorie', body: <EditLearnCategoryModal category={props.category} reload={props.reload} />, size: 'xl'})
  const {open: pinCategoryModal} = useModal({title: 'Pin categorie', body: <PinLearnCategoryModal category={props.category} reload={props.reload} />, size: 'md'})
  const {open: unpinCategoryModal} = useModal({title: 'Pin categorie', body: <UnpinLearnCategoryModal category={props.category} reload={props.reload} />, size: 'md'})
  const {open: deleteCategoryModal} = useModal({title: 'Archiveer categorie', body: <DeleteLearnCategoryModal category={props.category} reload={props.reload} />, size: 'md'})
  return <div className={`flex items-center space-x-3 py-3 bg-white border-slate-200 ${props.isFirst ? 'rounded-t border' : 'border-b border-l border-r'} ${props.isLast ? 'rounded-b' : ''} group hover:bg-brand-50 hover:cursor-pointer`}
              onClick={() => navigate(`/learn/categories/${props.category.id}`)}>
    <CheckBox
      state={props.selectedCategories.includes(props.category.id) ? 'checked' : 'unchecked'}
      onSelect={() => {
        props.setSelectedCategories(prev => {
          return [...prev, props.category.id];
        });
      }}
      onDeselect={() => {
        props.setSelectedCategories(prev =>  prev.filter(id => id !== props.category.id));
      }}
    />

    <div>
      <LearnIcon icon={props.category.icon} className={'text-brand-600 text-lg'} />
    </div>

    <div className={'flex-1'}>
      {props.category.name}
    </div>

    {props.category.is_pinned_category &&
      <div className={'px-3 py-0.5 bg-brand-600 rounded-full text-white font-medium text-xs'}><FontAwesomeIcon icon={faThumbtack} className={'mr-0.5'} /> Vastgezet</div>
    }

    <RoundedContextMenu options={[
      {icon: faArrowRightArrowLeft, label: 'Verplaatsen', onClick: () => moveCategoryModal()},
      {icon: faPencil, label: 'Bewerken', onClick: () => editCategoryModal()},
      ...(props.category.is_pinned_category ?
          [{icon: faThumbtackSlash, label: 'Losmaken', onClick: () => unpinCategoryModal()}] :
          [{icon: faThumbtack, label: 'Vastzetten', onClick: () => pinCategoryModal()}]),
      {icon: faX, label: 'Verwijderen', onClick: () => deleteCategoryModal()},
    ]} />
  </div>
}

const CheckBox: FC<{state: 'checked'|'unchecked', onSelect: () => void, onDeselect: () => void}> = props => {
  const handleClick: MouseEventHandler<HTMLButtonElement> = (e) => {
    e.stopPropagation()
    if (props.state === 'checked') {
      props.onDeselect()
    } else {
      props.onSelect()
    }
  }
  return <button onClick={handleClick} type={'button'} className={'ml-2 -mr-2 hover:bg-brand-surface-variant rounded-full flex items-center justify-center'}>
    <div className={`h-4 w-4 mx-3 my-3 flex items-center justify-center rounded-sm border-2 ${props.state === 'unchecked' ? 'border-brand-secondary bg-transparent' : 'border-brand-primary bg-brand-primary text-brand-on-primary'}`}>
      {props.state === 'checked' && <FontAwesomeIcon icon={faCheck} className={'w-3'} />}
    </div>
  </button>
}